export { getServerSideProps } from '@framework/ssr/shop';
import { getLayout } from '@components/layouts/layout';
import { ROUTES } from "@lib/routes";
import dynamic from 'next/dynamic';
import { isMobileOnly } from 'react-device-detect';
import { getLayout as getSiteLayoutMobile } from '@components/layouts/layout-mobile';
import { useShopQuery } from '@framework/shops/shops.query';

const Shop = dynamic(() => import("@framework/shops/shop"));

export default function ShopPage({ slug, locale }: any) {
  const {
    data: shop,
    isLoading,
  } = useShopQuery(slug, locale);

  const breadCrumTitles = [
    {text: "text-home", url: ROUTES.HOME},
    {text: "text-best-shop-title", url: ROUTES.BEST_SHOPS},
    {text: shop?.name, url: ""},
  ]

  return !isLoading && <Shop shop={shop} breadCrumTitles={breadCrumTitles} />;
}

const getLayoutMobile = (page: React.ReactElement) =>
  getSiteLayoutMobile(
    <>{page}</>
  );

ShopPage.getLayout = isMobileOnly ? getLayoutMobile : getLayout;
